// This runs inside Marketo's loadForm callback, where `form` is the live instance.
// Refresh submission URL at submit time so client navigation and UTMs remain accurate.
export const demoUrlTrackingScript = `
  if (/^\\/demo-request(?:-(?:shopping|booking|support|retention|midas))?\\/?$/.test(window.location.pathname)) {
    var demoLandingPage = window.location.href;
    try {
      var landingKey = 'delightDemoSessionLandingPage';
      demoLandingPage = sessionStorage.getItem(landingKey) || demoLandingPage;
      sessionStorage.setItem(landingKey, demoLandingPage);
    } catch (e) {}
    var setDemoTracking = function() {
      form.addHiddenFields({
        Form_Submission_URL__c: window.location.href,
        Session_Landing_Page__c: demoLandingPage
      });
    };
    setDemoTracking();
    form.onSubmit(setDemoTracking);
  }
`
